import {
  LANG_CH,
  LANG_EN,
  LANG_JP,
  LANG_KO,
  LANG_TH,
  langText,
} from "../../../../recoil/lang";
import { Style } from "./style";
import { TimeRecommendListViewProps } from "./type";

const TimeRecommendListView = ({ props }: TimeRecommendListViewProps) => {
  return (
    <Style>
      <div className="adverStoreWrap">
        <div>
          <div className="imageBox">
            <img
              className="adImg"
              src={props.timeSectorRecommend!.background_image_url!}
              alt="background_img"
            />
          </div>
        </div>

        <div className="titleWrap">
          <h2 className="title">{props.timeSectorRecommend!.title}</h2>
          <h1
            className={`${
              (props.lang === LANG_EN || props.lang > LANG_TH) && "mini"
            }`}
          >
            {props.timeSectorRecommend!.desc}
          </h1>
        </div>

        <div className="storebuttonWrap">
          {props.timeSectorRecommend!.store_data.map((item, index) => (
            <button
              key={`${item.store_id}_${index}`}
              className="storeButton"
              onClick={() => {
                props.navigateAdStore(item.store_id);
                props.adverClick(item.store_id, item.store_name);
              }}
            >
              <div className="orderCountWrap">
                <span>
                  {langText.section_recommend_orders_this_month[props.lang]}
                </span>
                <h3>
                  {props.lang !== LANG_KO &&
                    props.lang !== LANG_JP &&
                    props.lang !== LANG_CH &&
                    langText.section_recommend_orders[props.lang]}
                  {item.monthOrderCount}
                  {(props.lang === LANG_KO ||
                    props.lang === LANG_JP ||
                    props.lang === LANG_CH) &&
                    langText.section_recommend_orders[props.lang]}
                </h3>
              </div>
              <div className="storeNameWrap">
                <h2>{item.store_name}</h2>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right.svg`}
                  alt="right_arrow"
                />
              </div>
            </button>
          ))}
        </div>
      </div>
    </Style>
  );
};

export default TimeRecommendListView;
